import { pick } from 'remeda';

import { LOGIN_CALLBACK_PATH } from '../../nav/config';
import { parseQueryParams, setQueryParams } from '../../utils';
import { LoginExperience } from '../types';

/**
 * Query parameters passed to the configured Auth0 redirect URL. Useful for
 * error handling on the login-callback page.
 */
export type CustomRedirectUrlQueryParams = {
  /**
   * Path or URL to return the client to after a successful login and token
   * exchange
   */
  returnTo: string;
  /**
   * The login experience to use for the login attempt, useful for failure
   * scenarios where re-login is necessary
   */
  loginExperience: LoginExperience;
};

export const CUSTOM_REDIRECT_URL_QUERY_PARAM_KEYS: Set<keyof CustomRedirectUrlQueryParams> = new Set([
  'returnTo',
  'loginExperience',
]);

/**
 * Returns the URL that users should be redirected to after logging in
 */
export function getRedirectUrl(givenOrigin?: string): string {
  return `${givenOrigin ?? location.origin}${LOGIN_CALLBACK_PATH}`;
}

export function setCustomRedirectUrlQueryParams(
  baseURL: string,
  { returnTo, loginExperience }: CustomRedirectUrlQueryParams,
) {
  return setQueryParams(baseURL, {
    returnTo,
    loginExperience,
  });
}

export function getCustomRedirectUrlQueryParams(queryString: string): Partial<CustomRedirectUrlQueryParams> {
  return pick(parseQueryParams<{ [key: string]: unknown } & CustomRedirectUrlQueryParams>(queryString), [
    'returnTo',
    'loginExperience',
  ]);
}
